// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_7a2cefd1"};